import React from 'react';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '../ui/select';
import { setMonth, setYear, getMonth, getYear } from 'date-fns';

const MONTHS = [
  'Januar', 'Februar', 'März', 'April', 'Mai', 'Juni',
  'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember',
];

export function MonthYearPicker({ currentDate, onChange, yearRange = 3 }) {
  const currentMonth = getMonth(currentDate);
  const currentYear = getYear(currentDate);
  const now = new Date();
  const thisYear = getYear(now);

  const years = [];
  for (let y = thisYear - yearRange; y <= thisYear + yearRange; y++) {
    years.push(y);
  }

  const handleMonthChange = (monthStr) => {
    const newDate = setMonth(currentDate, parseInt(monthStr, 10));
    onChange(newDate);
  };

  const handleYearChange = (yearStr) => {
    const newDate = setYear(currentDate, parseInt(yearStr, 10));
    onChange(newDate);
  };

  /*
   * Hinweis: Die früheren ChevronLeft/ChevronRight neben dem Jahres-Dropdown
   * wurden 2026-05-08 entfernt. Sie waren visuell nicht von den Monats-Chevrons
   * (außerhalb dieser Komponente) zu unterscheiden und führten dazu, dass
   * Anwender:innen versehentlich um ein ganzes Jahr sprangen statt einen Monat
   * weiter — z.B. im Team-Kalender, wo Urlaubseinträge dann fälschlicherweise
   * "fehlten". Jahr-Wechsel passiert jetzt ausschließlich über das Dropdown.
   */
  return (
    <div className="flex items-center gap-1.5" data-testid="month-year-picker">
      <Select value={String(currentMonth)} onValueChange={handleMonthChange}>
        <SelectTrigger className="w-[130px] h-8 text-sm font-semibold border-none shadow-none bg-transparent hover:bg-secondary/50 focus:ring-0" data-testid="month-select">
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          {MONTHS.map((name, idx) => (
            <SelectItem key={name} value={String(idx)}>{name}</SelectItem>
          ))}
        </SelectContent>
      </Select>

      <Select value={String(currentYear)} onValueChange={handleYearChange}>
        <SelectTrigger className="w-[80px] h-8 text-sm font-semibold border-none shadow-none bg-transparent hover:bg-secondary/50 focus:ring-0" data-testid="year-select">
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          {years.map(y => (
            <SelectItem key={y} value={String(y)}>{y}</SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}
